var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fi_14269059",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "38 Scan QR",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m421.62 11h-331.24c-43.84 0-79.38 35.54-79.38 79.38v331.24c0 43.84 35.54 79.38 79.38 79.38h331.24c43.84 0 79.38-35.54 79.38-79.38v-331.24c0-43.84-35.54-79.38-79.38-79.38zm-338.76 153.01c0-44.75 36.4-81.16 81.15-81.16h41.38c11.05 0 20 8.95 20 20s-8.95 20-20 20h-41.38c-22.69 0-41.15 18.46-41.15 41.16v41.38c0 11.05-8.95 20-20 20s-20-8.95-20-20zm252.38 71.99c11.05 0 20 8.95 20 20s-8.95 20-20 20h-158.48c-11.05 0-20-8.95-20-20s8.95-20 20-20zm-129.85 193.14h-41.38c-44.75 0-81.15-36.41-81.15-81.16v-41.37c0-11.05 8.95-20 20-20s20 8.95 20 20v41.37c0 22.7 18.46 41.16 41.15 41.16h41.38c11.05 0 20 8.95 20 20s-8.95 20-20 20zm223.75-81.16c0 44.75-36.4 81.16-81.15 81.16h-41.38c-11.05 0-20-8.95-20-20s8.95-20 20-20h41.38c22.69 0 41.15-18.46 41.15-41.16v-41.37c0-11.05 8.95-20 20-20s20 8.95 20 20zm0-142.59c0 11.05-8.95 20-20 20s-20-8.95-20-20v-41.38c0-22.7-18.46-41.16-41.15-41.16h-41.38c-11.05 0-20-8.95-20-20s8.95-20 20-20h41.38c44.75 0 81.15 36.41 81.15 81.16z",
    fill: "#8BA4BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/Qr.3b4506036472822ca7e50b80b46fff7a.svg";
export { ForwardRef as ReactComponent };